import { Col, Form, Input, Row } from "antd"
import React from "react"

import InputNumber from "../../../../components/Input/InputNumber.tsx"
import { type ProjectTypeFormData } from "./ProjectType.tsx"

export function ProjectTypeMilestone() {
  const key: keyof ProjectTypeFormData = "phase"

  return (
    <>
      <Row gutter={12}>
        <Col xs={24} sm={10} xl={11}>
          <Form.Item<ProjectTypeFormData>
            label={"Milestone Name"}
            name={["phase", "name"]}
            rules={[{ required: true, message: "Please enter milestone name" }]}
          >
            <Input placeholder="Enter milestone name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={10} xl={7}>
          <Form.Item<ProjectTypeFormData>
            label={"Default Duration"}
            name={[key, "default_duration_days"]}
            rules={[
              { required: false, message: "Please enter default duration" }
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              max={999999999}
              precision={0}
              placeholder="0"
              suffix={"days"}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={6} xl={6}>
          <Form.Item<ProjectTypeFormData>
            label={"Default Budget"}
            name={[key, "default_budget"]}
            rules={[
              { required: false, message: "Please enter default budget" }
            ]}
          >
            <InputNumber
              prefix="$"
              style={{ width: "100%" }}
              min={0}
              max={999999999.99}
              precision={2}
              placeholder={"00.00"}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item<ProjectTypeFormData>
        label={"Description"}
        rules={[{ required: false }]}
        name={[key, "description"]}
      >
        <Input.TextArea
          rows={2}
          placeholder="Site clearing, excavation, utility connections, and initial preparation work for construction"
        />
      </Form.Item>

      <Form.Item<ProjectTypeFormData> name={[key, "id"]} hidden>
        <Input />
      </Form.Item>
    </>
  )
}
